import data from './attrs/data'
import methods from './attrs/methods'
import mounted from './attrs/mounted'
import { VueEditor } from "vue2-editor"
import { VueMonacoEditor } from '@guolao/vue-monaco-editor'

import { loader } from '@guolao/vue-monaco-editor'
loader.config({
  paths: {
    vs: 'https://cdn.jsdelivr.net/npm/monaco-editor@0.43.0/min/vs',
  },
})

export default {
  name: 'PagesForm',
  data,
  methods,
  mounted,
  components: {
    VueEditor,
    VueMonacoEditor
  }
}
